<div class="disclaimer-alert" *ngIf="!disableDisclaimer">{{ message }}</div>
